import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { DepositType } from '../../models/deposit-type.model';

@Injectable({
  providedIn: 'root'
})
export class DepositTypeService {
  constructor(private readonly http: HttpClient) {
  }

  fetchDepositTypes(): Observable<DepositType[]> {
    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.get<DepositType[]>('api/deposit-type', { headers });
  }
}
